import DocumentItem from "./documentItem";

const DocumentList = ({
  docsPerKindSorted,
  uploadedDocumentsIds,
  imageFormatErrorText,
  setImageFormatErrorText,
  arrayHelpers,
}) => {
  return (
    <div>
      {docsPerKindSorted?.map((docPerKind, index) => (
        <DocumentItem
          key={docPerKind?.id}
          docPerKind={docPerKind}
          index={index}
          uploadedDocumentsIds={uploadedDocumentsIds}
          imageFormatErrorText={imageFormatErrorText}
          setImageFormatErrorText={setImageFormatErrorText}
          arrayHelpers={arrayHelpers}
        />
      ))}
    </div>
  );
};

export default DocumentList;
